module.exports = __webpack_public_path__ + "static/2-3500583367bd16cf42f49e24c2909ca2.gif";